import { FormLabel } from "@mui/material";
import Autocomplete, {
  AutocompleteInputChangeReason,
} from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";

interface AutoCompleteSelectProps {
  fieldId: string;
  options: string[];
  onSelect: (fieldId: string, value: string) => void;
  placeholder?: string;
  initialValue?: any;
  required?: boolean;
  disabled?: boolean;
}

const AutoCompleteSelect = (props: AutoCompleteSelectProps) => {
  const { t } = useTranslation();
  const {
    fieldId,
    options,
    placeholder,
    initialValue,
    required,
    disabled,
    onSelect,
  } = props;
  const sortedOptionsAsc = options.sort((a, b) => t(a).localeCompare(t(b)));

  const handleInputChange = (
    event: React.SyntheticEvent,
    value: string,
    reason: AutocompleteInputChangeReason,
  ) => {
    if (reason === "blur" || reason === "input") return;
    if (reason === "clear") onSelect(fieldId, "");

    const rawValue = options.find((option) => t(option) === value);
    if (rawValue) onSelect(fieldId, rawValue);
  };

  return (
    <Autocomplete
      options={sortedOptionsAsc}
      getOptionLabel={(option) => t(option)}
      id={"auto-complete-select" + "-" + fieldId}
      autoComplete
      value={initialValue}
      blurOnSelect
      includeInputInList
      onInputChange={handleInputChange}
      disabled={disabled}
      renderInput={(params) => (
        <>
          <FormLabel required={required}>{t(fieldId)}</FormLabel>
          <TextField
            {...params}
            data-testid={"auto-complete-select" + "-" + fieldId}
            className="input-element"
            id={fieldId}
            variant="outlined"
            placeholder={placeholder || t("selectPlaceholder")}
            required={required}
          />
        </>
      )}
    />
  );
};

export default AutoCompleteSelect;
